<template>
  <v-card flat class="rmr-table-shell">
    <sources-results-toolbar
      :search="results.page.search"
      :sort-by="results.page.sortBy"
      :view="results.page.view"
      :hide-treated="results.page.hideTreated"
      :shown-count="results.shownCount.value"
      :total="results.pagination.total"
      :is-video="results.isVideo.value"
      @update:search="results.page.search = $event"
      @update:sortBy="results.page.sortBy = $event"
      @update:view="results.page.view = $event"
      @update:hideTreated="results.page.hideTreated = $event"
    />

    <v-card-text class="rmr-table-shell__body">
      <sources-table-view
        v-if="results.page.view === 'table'"
        :items="results.visibleItems.value"
        :loading="results.page.loading"
        :options="results.pagination.options"
        :total="results.pagination.total"
        :expanded-items="expandedItems"
        :is-selected="selection.isSelected"
        :is-expanded="isExpanded"
        :is-video="results.isVideo.value"
        @update:options="onOptionsChange"
        @toggle-select="selection.toggle"
        @toggle-expand="toggleExpand"
        @open-video="$emit('open-video', $event)"
      />

      <sources-cards-view
        v-else
        :items="results.visibleItems.value"
        :loading="results.page.loading"
        :options="results.pagination.options"
        :total="results.pagination.total"
        :is-selected="selection.isSelected"
        :is-expanded="isExpanded"
        :is-video="results.isVideo.value"
        @update:page="onPageChange"
        @toggle-select="selection.toggle"
        @toggle-expand="toggleExpand"
        @open-video="$emit('open-video', $event)"
      />
    </v-card-text>
  </v-card>
</template>

<script>
import { computed, reactive, set, del } from "@vue/composition-api";

import SourcesCardsView from "./parts/SourcesCardsView.vue";
import SourcesResultsToolbar from "./parts/SourcesResultsToolbar.vue";
import SourcesTableView from "./parts/SourcesTableView.vue";

export default {
  name: "SourcesResultsCard",
  components: {
    SourcesCardsView,
    SourcesResultsToolbar,
    SourcesTableView,
  },
  props: {
    // Returned by useGlobalWatchResults()
    results: {
      type: Object,
      required: true,
    },
    // Returned by useGlobalWatchSelection()
    selection: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    // Expansion is per article and independent of selection: several rows can
    // be open at once, and both views share the same state.
    const state = reactive({ expandedById: {} });

    const isExpanded = (id) =>
      Object.prototype.hasOwnProperty.call(state.expandedById, id);

    const toggleExpand = (item) => {
      if (isExpanded(item.id)) del(state.expandedById, item.id);
      else set(state.expandedById, item.id, true);
    };

    // v-data-table wants the item objects, not their ids.
    const expandedItems = computed(() =>
      props.results.visibleItems.value.filter((item) => isExpanded(item.id))
    );

    const onOptionsChange = (options) => {
      Object.assign(props.results.pagination.options, options);
    };

    const onPageChange = (pageNumber) => {
      props.results.pagination.options.page = pageNumber;
    };

    return {
      expandedItems,
      isExpanded,
      onOptionsChange,
      onPageChange,
      toggleExpand,
    };
  },
};
</script>
